import type { GlycerinProductClickPayload } from '@packages/tracking';
import { GlycerinPlacement } from '@packages/tracking';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

import type { ProductCardProps } from '@packages/modules/src/ProductCard/types';

export const SearchProductCardGlycerinTrackingResultFragment = graphql(/* GraphQL */ `
  fragment SearchProductCardGlycerinTrackingResultFragment on SearchProductResult {
    categories {
      name
      isSelected
    }
  }
`);

export const SearchProductCardGlycerinTrackingItemFragment = graphql(/* GraphQL */ `
  fragment SearchProductCardGlycerinTrackingItemFragment on StylePreviewItem {
    styleId
    styleName
    brand {
      name
    }
    listPosition
  }
`);

export const SearchProductCardGlycerinTrackingVariationGroupFragment = graphql(/* GraphQL */ `
  fragment SearchProductCardGlycerinTrackingVariationGroupFragment on CompleteVariationGroup {
    sku
    articleNumber
  }
`);

export const buildGlycerinTrackingData = (
  maskedResult: FragmentType<typeof SearchProductCardGlycerinTrackingResultFragment>,
  maskedItem: FragmentType<typeof SearchProductCardGlycerinTrackingItemFragment>,
  maskedVariationGroup: FragmentType<
    typeof SearchProductCardGlycerinTrackingVariationGroupFragment
  >,
) => {
  const {
    styleId: productId,
    brand: { name: brand },
    styleName: title,
    listPosition,
  } = getFragmentData(SearchProductCardGlycerinTrackingItemFragment, maskedItem);
  const { articleNumber: articleId, sku: skuId } = getFragmentData(
    SearchProductCardGlycerinTrackingVariationGroupFragment,
    maskedVariationGroup,
  );
  const { categories } = getFragmentData(
    SearchProductCardGlycerinTrackingResultFragment,
    maskedResult,
  );

  const currentCategoryName = categories.find((category) => category.isSelected)?.name;

  const listId = currentCategoryName || 'Search Result';

  const clickTrackingProps: GlycerinProductClickPayload = {
    category: 'product-click',
    productId,
    articleId,
    detail: `${brand} ${title}`,
    listPosition,
    skuId,
    listId,
    placement: GlycerinPlacement.LISTING,
  };

  const wishListTrackingProduct: NonNullable<ProductCardProps['wishListTrackingProps']>['product'] =
    {
      productId,
      articleId,
      listPosition,
      origin: listId,
    };

  return {
    clickTrackingProps,
    wishListTrackingProduct,
  };
};
